// extracted by mini-css-extract-plugin
export default {"eyebrow":"DrawerEyebrow_eyebrow__I3vZ1"};